export enum ApplicationType {
  Dashboard = 'DASHBOARD',
  DriverApp = 'DRIVER_APP',
}

export enum DataProtectionNoticeStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum DpnItemFormGroupName {
  Type = 'type',
  Dpn = 'dpn',
}
